import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  ViewChildren,
  QueryList,
  HostListener,
  AfterViewInit,
  Renderer2,
} from "@angular/core";
import { Router } from "@angular/router";
import {
  MatLegacyMenu,
  MatLegacyMenuTrigger,
} from "@angular/material/legacy-menu";
import { Subscription } from "rxjs";

import {
  IPortfolio,
  PortfolioService,
  PortfolioResponse,
} from "../../shared/services/portfolio.service";
import { LoginService } from "../../login/services/login.service";
import { UserService } from "../../shared/services/user.service";
import { BasketCheckPaymentsService } from "../../transfers/services/basket-check-payments.service";
import { DialogStateService } from "../../dialogs/services/dialog-state.service";
import { timeout } from "rxjs/operators";
import { FullPortfolioViewService } from "./../../shared/services/full-portfolio-view.service";

@Component({
  selector: "ab-portfolio-selector",
  templateUrl: "./portfolio-selector.component.html",
  styleUrls: ["./portfolio-selector.component.scss"],
})
export class PortfolioSelectorComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @Input() rendering: any;
  @ViewChildren(MatLegacyMenu) matMenuPortfolio: QueryList<MatLegacyMenu>;
  @ViewChildren(MatLegacyMenuTrigger)
  menuTriggers: QueryList<MatLegacyMenuTrigger>;

  private portfolioMenuTrigger: MatLegacyMenuTrigger;
  private isMenuOpen: boolean;
  private subscriptions: Subscription[] = [];

  public portfolios: IPortfolio[];
  public username: string;
  isLoading = false;
  isLoadingPortfolios = true;

  constructor(
    private portfolioService: PortfolioService,
    private loginService: LoginService,
    private router: Router,
    private userService: UserService,
    private basketCheckPaymentsService: BasketCheckPaymentsService,
    private dialogStateService: DialogStateService,
    private renderer: Renderer2,
    private fullPortfolioViewService: FullPortfolioViewService
  ) {}

  @HostListener("document:click", ["$event"])
  documentClick(event) {
    if (
      document.querySelector(".portfolio-actions-list") &&
      !document
        .querySelector(".portfolio-actions-list")
        .contains(event.target as Node)
    ) {
      if (this.portfolioMenuTrigger && !this.isMenuOpen) {
        this.portfolioMenuTrigger.closeMenu();
        this.portfolioMenuTrigger = undefined;
        return;
      }

      this.isMenuOpen = false;
    }
  }

  ngOnInit() {
    this.getPortfolios();
  }

  ngAfterViewInit() {
    this.menuTriggers.changes.subscribe(() => {
      this.menuTriggers.forEach((menuTrigger) => {
        menuTrigger.menuOpened.subscribe(() => {
          this.portfolioMenuTrigger = menuTrigger;
          this.isMenuOpen = true;
        });
      });
    });
  }

  getPortfolios() {
    this.subscriptions.push(
      this.fullPortfolioViewService.getFullPortfolioView().subscribe((res) => {
        this.subscriptions.push(
          this.portfolioService.getPortfolios().subscribe((response) => {
            this.isLoadingPortfolios = false;
            this.publishSelectedPortfolio(response);
            this.portfolios = response.portfolios;
            this.username = response.name;
          })
        );
      })
    );
  }

  publishSelectedPortfolio(response: PortfolioResponse): void {
    response.portfolios.map((portfolio) => {
      if (portfolio.isSelected) {
        this.portfolioService.setCurrentPortfolio(portfolio);
      }
    });
  }

  changePortfolio(portfolioId: string) {
    this.subscriptions.push(
      this.portfolioService
        .changePortfolio({ portfolioId: portfolioId })
        .subscribe((response) => {
          if (response.updated) {
            var url = this.rendering.fields.HomeLink.url;
            this.router.navigate([url]);
          }
        })
    );
  }

  logout() {
    this.showLoader();
    this.subscriptions.push(
      this.basketCheckPaymentsService
        .checkPayments()
        .pipe(timeout(5000))
        .subscribe(
          (response) => {
            this.hideLoader();
            if (response) {
              this.dialogStateService
                .openDialog("PendingApproval")
                .subscribe((response) => {
                  if (response) {
                    this.logoutUser();
                  }
                });
            } else {
              this.logoutUser();
            }
          },
          () => {
            this.logoutUser();
          }
        )
    );
  }

  logoutUser() {
    this.loginService.logout().subscribe((response) => {
      if (response.callIsSuccess) {
        this.userService.logoutUser();
      }
    });
  }

  ngOnDestroy() {
    if (this.subscriptions) {
      this.subscriptions.forEach((subscription) => {
        subscription.unsubscribe();
      });
    }
  }

  private showLoader() {
    this.renderer.setStyle(document.body, "overflow", "hidden");
    this.isLoading = true;
  }

  private hideLoader() {
    this.renderer.removeStyle(document.body, "overflow");
    this.isLoading = false;
  }
}